/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { HighFrequencyBackupSchedules } from '../models/HighFrequencyBackupSchedules';

export class LlgPolicyPlan {
  'backupSchedule': HighFrequencyBackupSchedules;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "backupSchedule",
      "baseName": "backupSchedule",
      "type": "HighFrequencyBackupSchedules",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LlgPolicyPlan.attributeTypeMap;
  }

  public constructor() {
  }
}

